var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import InfoIcon from "../assets/icons/Info.svg";
import Tooltip from "../Tooltip";
const InputWithTooltip = (_a) => {
    var { className, tooltipIcon, tooltipAlt, children } = _a, props = __rest(_a, ["className", "tooltipIcon", "tooltipAlt", "children"]);
    return (React.createElement("div", { className: "position-relative " + className },
        children,
        React.createElement(Tooltip, Object.assign({}, props),
            React.createElement("img", { src: tooltipIcon || InfoIcon, tabIndex: 0, className: "input-inner-element cursor-help", alt: tooltipAlt }))));
};
export default InputWithTooltip;
//# sourceMappingURL=index.js.map